<div class="WholeScreen">
    <div id="crossButton">
        <button (click)="closeIframe()" style="border-radius: 0px 0px 2px 3px;"
            class="fa fa-times btn btn-danger p-1"></button>
    </div>
    <div class="shortcutkeys">
        <button class="start-btn" (click)="startRecording()" [disabled]="isRecording">
            <i class="fa fa-play-circle"></i>
        </button>

        <!-- <button class="pause-btn" (click)="togglePause()" [disabled]="!isRecording">
            <i [class.fa-pause-circle]="!isPaused" [class.fa-play-circle]="isPaused"></i>
        </button> -->
        <button type="button" class="pause-btn" [disabled]="!isRecording" [title]="isPaused ? 'Resume' : 'Pause'"
            (click)="toggleRecord()">
            <i [class]="isPaused ? 'fa fa-play-circle' : 'fa fa-pause-circle'"></i>
        </button>

        <button class="stop-btn" (click)="stopRecording()" [disabled]="!isRecording">
            <i class="fa fa-stop-circle"></i>
        </button>

        <button class="screenshot-btn" (click)="takeScreenshot()">
            <i class="fa fa-camera"></i>
        </button>
    </div>

    <iframe #myIframe width="100%" height="100%" [src]="trustedUrl" allowfullscreen  ></iframe>
</div>
<ng-template #alerttemplate let-modal>
    <div class="modal-body text-center">
        <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
        <div class="alert-actions">
            <button type="button" class="btn btn-success" (click)="Ok()">OK</button>&nbsp;
        </div>
    </div>
</ng-template>